import constants from '../../constants/app-constants';

export const showMessage = (message) => {
  return {
    type: constants.GLOBALMESSAGE_SET,
    payload: message
  };
};